module.exports = __webpack_public_path__ + "static/media/doctor_clipboard.4bff5e59.svg";